module.exports = __webpack_public_path__ + "img/HC2018-164.1b9b6e48.jpg";